import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { desktop_medium, mobile_xl, mobile_xs } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter } from '../../global/commonStyle';

interface Props {
  status?: string;
  isActive?: boolean;
  isCustomerDetailInvoice?: boolean;
}

const Pagedata = styled.div``;

const HeaderBlock = styled.div`
  ${AlignCenter}
  gap: var(--space-20);
`;
const Buttons = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  ${mobile_xl(css`
    padding-block: var(--space-12);
    gap: var(--space-5);
  `)}
`;
const Group = styled.div`
  height: 100vh;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  position: relative;
  padding-inline: var(--space-24);
  ${mobile_xl(css`
    padding-inline: var(--space-20);
  `)}
`;

const ArrowBtn = styled.div`
  width: 66px;
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-full);
  display: flex;
  .left-arrow-icon {
    box-shadow: none;
    border-radius: var(--border-radius-full) var(--border-radius-0) var(--border-radius-0) var(--border-radius-full);
    border-right: 0.5px solid var(--border-primary);
  }
  .right-arrow-icon {
    box-shadow: none;
    border-radius: var(--border-radius-0) var(--border-radius-full) var(--border-radius-full) var(--border-radius-0);
  }
  ${mobile_xl(css`
    width: auto;
    background: unset;
    border: unset;
    gap: var(--space-4);
    .left-arrow-icon {
      border-radius: var(--border-radius-8);
      border-right: none;
    }
    .right-arrow-icon {
      border-radius: var(--border-radius-8);
    }
  `)}
`;
const Downarrow = styled.div`
  display: flex;
  .arrow-open {
    transform: rotate(180deg);
  }
  ${mobile_xl(css`
    svg {
      width: 18px;
      height: 18px;
    }
  `)}
`;
const Dropbox = styled.div``;

const LeftDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
  ${mobile_xl(css`
    gap: var(--space-8);
  `)}
`;
const Pagination = styled.div`
  ${FlexCenter}
  gap: var(--space-32);
  padding-block: var(--space-40);
  ${mobile_xl(css`
    padding-block: var(--space-20) var(--space-96);
    justify-content: space-between;
    gap: var(--space-20);
  `)}
  ${mobile_xs(css`
    flex-direction: column;
  `)}
`;

const RightDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
  ${mobile_xl(css`
    gap: var(--space-8);
  `)}
`;
const RowText = styled.div`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
`;
const ShowRow = styled.div`
  border-radius: var(--border-radius-full);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  padding: var(--space-7) var(--space-7) var(--space-7) var(--space-11);
  ${AlignCenter}
  gap: var(--space-18);
  cursor: pointer;
  ${mobile_xl(css`
    padding: unset;
    border: unset;
    background-color: unset;
    gap: var(--space-4);
  `)}
`;
const Text = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
`;

const HeaderLeft = styled.div`
  ${AlignCenter}
  gap: var(--space-24);
`;

const Icon = styled.div`
  display: inline-flex;
  position: relative;
`;
const OptionMenu = styled.div<Props>`
  display: flex;
  position: relative;
  .invoice-more-icon {
    &:hover {
      background-color: var(--background-muted);
    }
  }
  ${mobile_xl(css`
    padding: var(--space-20) var(--space-12);
    background-color: var(--background-primary);
    ${AlignCenter}
    box-shadow: var(--shadow-card);
    &.active-state {
      background-color: var(--neutral-secondary);
    }
    .invoice-more-icon {
      &:hover {
        background-color: unset;
      }
    }
  `)}
`;

export const TableWrapper = styled.div`
  border-radius: var(--border-radius-8);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-spacing: 0;
  tbody {
    tr {
      border-bottom: 0.5px solid var(--border-primary);
      &:last-child {
        border-bottom: none;
      }
    }
  }
`;
export const TableHead = styled.thead`
  background-color: var(--background-tertiary);
  tr {
    border-bottom: 0.5px solid var(--border-primary);
    width: 100%;
    display: flex;
    gap: var(--space-20);
    justify-content: space-between;
    ${mobile_xl(css`
      justify-content: unset;
    `)}
  }
`;

export const TableHeadGroup = styled.div`
  max-width: 621px;
  ${AlignCenter}
  gap: var(--space-20);
  th {
    min-width: 133px;
    &:first-child {
      min-width: 133px;
      max-width: unset;
      p {
        box-shadow: var(--left-border);
      }
    }
    &:last-child {
      min-width: 120px;
      ${desktop_medium(css`
        all: unset;
        min-width: 120px;
      `)}
      ${mobile_xl(css`
        min-width: 120px;
      `)}
    }
  }
`;

export const TableHeader = styled.th`
  padding: var(--space-12) var(--space-0);
  text-align: left;
  p {
    margin: var(--space-0);
    padding-left: var(--space-12);
    ${Typography.body_md_medium}
    color: var(--text-secondary);
    text-transform: uppercase;
  }
  &:first-child {
    max-width: 650px;
    width: 100%;
    border-top-left-radius: var(--border-radius-8);
    min-width: 355px;

    ${mobile_xl(css`
      min-width: 200px;
      max-width: 200px;
    `)}
  }

  &:not(:first-child) {
    p {
      box-shadow: var(--left-border);
    }
  }
  &:nth-child(2) {
    min-width: 150px;
  }
  &:nth-child(3) {
    min-width: 150px;
    text-align: right;
  }
  &:nth-child(4) {
    p {
      padding-left: var(--space-16);
    }
  }
  &:last-child {
    min-width: unset;
    border-top-right-radius: var(--border-radius-8);
    border-left: none;
    min-width: 36px;
    ${desktop_medium(css`
      position: sticky;
      right: 0;
      background-color: var(--background-tertiary);
      box-shadow: var(--shadow-card);
      min-width: 48px;
    `)}
    ${mobile_xl(css`
      min-width: 50px;
    `)}
  }
`;

export const TableRow = styled.tr<Props>`
  ${FlexBetween}
  gap: var(--space-20);
  cursor: pointer;
  &:hover {
    background-color: var(--neutral-secondary);
  }
  ${(props: Props) =>
    props.isActive &&
    css`
      background-color: var(--neutral-secondary);
    `}
`;

export const TableDataGroup = styled.div`
  max-width: 621px;
  ${AlignCenter}
  gap: var(--space-20);
  td {
    min-width: 133px;
    &:first-child {
      min-width: 133px;
      max-width: unset;
    }
    &:last-child {
      all: unset;
      min-width: 120px;
      padding-right: var(--space-0);
      h2 {
        padding-left: var(--space-16);
      }
    }
  }
`;

export const TableData = styled.td`
  padding: var(--space-7) var(--space-0);
  p {
    margin: var(--space-0);
    ${Typography.body_md_medium}
    color: var(--text-secondary);
  }
  &:first-child {
    max-width: 650px;
    width: 100%;
    min-width: 355px;
    ${mobile_xl(css`
      min-width: 200px;
      max-width: 200px;
    `)}
  }
  &:nth-child(2) {
    min-width: 150px;
  }
  &:nth-child(3) {
    min-width: 150px;
    text-align: right;
  }
  &:last-child {
    padding-right: var(--space-12);
    min-width: max-content;
    ${desktop_medium(css`
      position: sticky;
      right: 0;
      padding: var(--space-16) var(--space-12);
      background-color: var(--background-primary);
      ${AlignCenter}
      box-shadow: var(--shadow-card);
    `)}
    ${mobile_xl(css`
      padding: var(--space-0);
    `)}
    .active {
      background-color: var(--background-muted);
      border-radius: var(--border-radius-4);
    }
  }
`;

export const CompanyDetails = styled.div<Props>`
  padding-left: ${({ isCustomerDetailInvoice }) => (isCustomerDetailInvoice ? 'var(--space-20)' : 'var(--space-12)')};
  display: flex;
  flex-direction: column;
  gap: ${({ isCustomerDetailInvoice }) => (isCustomerDetailInvoice ? 'var(--space-4)' : 'var(--space-2)')};
`;

export const CustomerName = styled.h1`
  margin: var(--space-0);
  ${Typography.body_md_medium}
  color: var(--text-primary);
`;
export const CompanyName = styled.p`
  margin: var(--space-0);
  ${Typography.body_md}
  color: var(--text-secondary);
`;

export const InvoiceNumber = styled.h2<Props>`
  padding-left: var(--space-12);
  margin: var(--space-0);
  ${Typography.body_md_medium}
  color: var(--text-primary);
  text-transform: uppercase;
  ${(props: Props) =>
    props.status === 'PENDING' &&
    css`
      color: var(--accent-caution);
    `}
  ${(props: Props) =>
    (props.status === 'PAID' || props.status === 'PARTIALLY PAID') &&
    css`
      color: var(--accent-success);
    `} 
    ${(props: Props) =>
    (props.status === 'DRAFT' || props.status === 'DUE') &&
    css`
      color: var(--text-secondary);
    `}
    ${(props: Props) =>
    props.status === 'OVER DUE' &&
    css`
      color: var(--accent-error);
    `}
`;

export {
  Pagedata,
  HeaderBlock,
  Buttons,
  Group,
  ArrowBtn,
  Downarrow,
  Dropbox,
  LeftDiv,
  Pagination,
  RightDiv,
  RowText,
  ShowRow,
  Text,
  HeaderLeft,
  Icon,
  OptionMenu
};
